import { createRoot } from 'react-dom/client';
import App from './App';
import ErrorBoundary from './shared/error/error-boundary-catcher';
import { registerLocale } from './config/translation';
import getStore from './store/store';
import { Provider } from 'react-redux';
import { ReactKeycloakProvider } from '@react-keycloak/web';
import keycloak from './config/keycloak';

const store = getStore(); // get redux store
registerLocale(store); // register locale from /config/translation

const rootElement = document.getElementById('root');
// New as of React v18.x
const root = createRoot(rootElement!);

root.render(
  <Provider store={store}>
    <ErrorBoundary>
      <ReactKeycloakProvider
        authClient={keycloak}
        initOptions={{
          //onLoad: 'check-sso',
          onLoad: 'login-required',
          // for silent renew
          // silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html',
          checkLoginIframe: false, // optional, but easier
        }}
        onEvent={(event, error) => {
          // Events: onReady, onInitError, onAuthSuccess, onAuthError, onAuthRefreshSuccess, onAuthRefreshError, onTokenExpired, onAuthLogout
          console.log('[Keycloak:event]', event, error ?? '');
          if (event === 'onInitError' || event === 'onAuthError' || event === 'onAuthRefreshError') {
            console.error('[Keycloak:error]', error);
          }
        }}
        onTokens={tokens => {
          console.log('[Keycloak:tokens]', {
            token: Boolean(tokens?.token),
            refreshToken: Boolean(tokens?.refreshToken),
            idToken: Boolean(tokens?.idToken),
          });
        }}
        LoadingComponent={<div style={{ padding: 16 }}>Connecting to identity provider…</div>}
      >
        <App />
      </ReactKeycloakProvider>
    </ErrorBoundary>
  </Provider>,
);
